import { Box, Text, Flex, Button, Link } from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import { MeContext } from '../../context/MeContext';
import { CustomHourglassIcon } from '../../theme/icons/CustomHourglassIcon';
import { useBilling } from '../../store/client/BillingContext';

const TrialBanner = (props) => {
  const meCtx = useContext(MeContext);
  const { subscription } = useBilling();
  const isSetUpConfirmed = meCtx?.isSetUpConfirmed;
  const {
    billingEnabled,
    organisationStatus,
    trialExpiry,
    cardlessTrialStartedAt,
  } = meCtx.state;

  const { onTrial } = subscription || {
    onTrial: false,
  };

  // Calculate days remaining in trial
  let trialDaysRemaining = null;
  if (organisationStatus === 'trial' && !!trialExpiry) {
    const trialEnd = new Date(trialExpiry);
    const today = new Date();
    trialDaysRemaining = Math.ceil((trialEnd - today) / (1000 * 60 * 60 * 24));
  }

  const displayTrialEnd =
    isSetUpConfirmed &&
    organisationStatus === 'trial' &&
    trialDaysRemaining &&
    !cardlessTrialStartedAt &&
    !billingEnabled;

  return (
    displayTrialEnd && (
      <Box
        p={6}
        bg="gradientOrange"
        borderRadius="15px"
        position="relative"
        _before={{
          content: '""',
          position: 'absolute',
          inset: 0,
          padding: '1.5px',
          borderRadius: 'inherit',
          background: 'linear-gradient(180deg, #FF9554 16%, #FF4935 100%)',
          WebkitMask:
            'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          pointerEvents: 'none',
        }}
        mt={props.mt}
        mb={props.mb}
      >
        <Flex
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Flex direction="row" alignItems="center" gap="5px">
            <CustomHourglassIcon width="40px" height="40px" />

            <Flex direction="column" pl="10px">
              <Text
                textStyle="bodyFamilyMedium"
                bgClip="text"
                bgGradient="linear(to-b, #FF9554, #FF4935)"
                fontSize="20px"
              >
                Your trial ends in {trialDaysRemaining} day
                {trialDaysRemaining > 1 ? 's' : ''}
              </Text>
              <Text textStyle="bodyFamilyRegular" fontSize="14px">
                Contact{' '}
                <Link href="mailto:sales@passentry.com">
                  sales@passentry.com
                </Link>{' '}
                to continue
              </Text>
            </Flex>
          </Flex>
          <Button
            variant="secondary"
            onClick={() => {
              window.open('mailto:sales@passentry.com', '_blank');
            }}
          >
            <Text>Contact us</Text>
          </Button>
        </Flex>
      </Box>
    )
  );
};

export default TrialBanner;
